import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/fbpixel';

/**
 * Headless component placed inside <BrowserRouter>.
 * Fires fbq('track', 'PageView') on every client-side route change.
 * (The initial PageView is already fired by the pixel snippet in index.html.)
 */
const PageViewTracker = () => {
  const location = useLocation();
  const isInitial = location.key === 'default';

  useEffect(() => {
    if (isInitial) return; // initial load already tracked by inline snippet
    trackPageView(location.pathname);
  }, [location.pathname, location.search, isInitial]);

  return null;
};

export default PageViewTracker;
